

import axiosApiInstance from "infrastructure/utils/api";

export const fetchGetRequestsWithPagination = async (
  url: string,
  page?: number,
  limit?: number
) => {
  const response = await axiosApiInstance.get(url, {
    params: { page: page, limit: limit },
  });

  return response.data.data;
};

export const fetchGetRequests = async (url: string) => {
  let response: any;
  let error;
  await axiosApiInstance
    .get(url)
    .then((res) => {
      response = res.data;
    })
    .catch((err) => {
      error = err.response.data.statusCode;
    });
  return { response, error };
};

export const fetchDeleteRequests = async (url: string) => {
  const response = await axiosApiInstance.delete(url);
  return response.data.data;
};
